var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('database-picker',{attrs:{"color":_vm.color,"return-id":_vm.returnId,"rules":_vm.rules,"action":"/api/v1/taraf-sifati/","label":"Taraf Sıfatı *","cache-active":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }